import { btoau } from 'b2a';
import getConfig from 'next/config';

const COLON = ':';
const ZENDESK = 'zendesk.com';

const {
  publicRuntimeConfig: {
    loginUrl: LOGIN_URL,
    registerUrl: REGISTER_URL,
    siteUrl: WEB_SITE_URL,
  },
} = getConfig();

// DEFAULT_HOST will be used in localhost only
const DEFAULT_HOST = 'www.binance.com';

const getHostNameWithPort = (req) => req ? req.get('host') :
  (typeof window !== 'undefined' && window.location.host) || DEFAULT_HOST;

export const getHostName = (req) => {
  const hostNameWithPort = getHostNameWithPort(req);
  return hostNameWithPort.indexOf(COLON) === -1 ?
    hostNameWithPort : hostNameWithPort.split(COLON)[0];
};

export const shouldUseAltUrl = req => {
  const hostname = getHostName(req);
  return hostname !== DEFAULT_HOST;
};

export const shouldUseAltWssUrl = req => shouldUseAltUrl(req);

export const getSuffix = (host = '') => (
  (host || WEB_SITE_URL).split('.')
    .slice(1)
    .join('.')
);

/* deprecated: pls not use */
export const getInfoBase = (locale) => {
  const infoLocale = locale === 'cn' ? 'cn' : 'en';
  return `https://info.${getSuffix()}/${infoLocale}`;
};


export const getInfoApiBase = () => WEB_SITE_URL;

export const getUrlParam = (key) => {
  if (typeof window !== 'undefined') {
    const search = window.location.search.substr(1);
    const params = search.split('&');
    for (let i = 0; i < params.length; i++) {
      const keyValueArray = params[i].split('=');
      if (key === keyValueArray[0]) {
        return keyValueArray[1];
      }
    }
  }
  return null;
};

function getSiteOrigin() {
  if (typeof window === 'undefined') {
    return WEB_SITE_URL;
  }
  return window.location.origin;
}
// eslint-disable-next-line max-len
export const getLoginUrl = (locale = 'en', callbackUrl = '') => {
  const loginUrl = typeof window === 'undefined' ? LOGIN_URL : `https://accounts.${document.domain.split('.').slice(-2).join('.')}/%locale/login`;
  return `${loginUrl.replace('%locale', locale)}?return_to=${btoau(callbackUrl ? getSiteOrigin() + callbackUrl : getSiteOrigin())}`;
};
export const getRegisterUrl = (locale = 'en', callbackUrl = '') => {
  const loginUrl = typeof window === 'undefined' ? REGISTER_URL : `https://accounts.${document.domain.split('.').slice(-2).join('.')}/%locale/register`;
  return `${loginUrl.replace('%locale', locale)}?return_to=${btoau(callbackUrl ? getSiteOrigin() + callbackUrl : getSiteOrigin())}`;
};

// relative url cannot start with  // or /\ or \\ etc. as this will allow open redirect in javascript
// Example: //google.com
const relativePathRegx = new RegExp('^/$|^(/[\\w.?&=-]+[/\\w.?&=-]*)$');

// relative path
const checkRelative = (url) => relativePathRegx.test(url);

const checkAbsolute = (url) => {
  // todo white list remotely
  const whiteList = [
    'devfdg.net',
    'qa1fdg.net',
    'binance.com',
    'binance.net',
    'binance.co',
    'binance.vision',
    'binance.sg',
    'binance.co.ug',
    'binancezh.com',
    'binance-cn.com',
    'binance.charity',
    'binance.zendesk.com',
    'binancesingapore.zendesk.com',
    'binanceuganda.zendesk.com',
  ];
  try {
    const callback = new URL(url);
    if (url.includes(ZENDESK)) {
      return !!whiteList.find(w => `${callback.protocol}//${w}` === callback.origin);
    }
    return !!whiteList.find(w => callback.origin.endsWith(`.${w}`));
  } catch (_) {
    return false;
  }
};

export const checkCallback = (url) => {
  /* to prevent payloads such as
  https://www.binance.com()@google.com
  https://google.com%5www.binance.com
  */
  if (url.includes('@') || url.includes('\\')) {
    return false;
  }

  // treat all url that do not start with http as relative url
  if (!url.startsWith('http')) {
    return checkRelative(url);
  }
  return checkAbsolute(url);
};
export const getHostUrl = (req) => {
  let url = '';
  if (typeof window === 'undefined') {
    url = `${req.protocol}://${req.get('host')}`;
  } else {
    url = window.location.origin;
  }
  return url;
};
